module.exports = __webpack_public_path__ + "static/img/nobunaka_logo.a2b257c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/nobunaka_logo.png
// module id = nDwI
// module chunks = 0